import React from "react";
import './teacher-engagement-list.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import TeacherEngagementScore from "../teacher-engagement-score/teacher-engagement-score";

class TeacherEngagementList extends React.Component {


    state = {
        teachersList: this.props.teachersList
    }


    back() {
        this.props.back && this.props.back()
    }

    showTeacherEngagementScore(item) {
        this.setState({ showTeacherEngagementScore: true, selectedItem: item })
    }

    hideTeacherEngagementScore() {
        this.setState({ showTeacherEngagementScore: false, selectedItem: '' })
    }



    render() {

        if (this.state.showTeacherEngagementScore) {
            return <TeacherEngagementScore back={() => this.hideTeacherEngagementScore()} 
            selectedItem={this.state.selectedItem} selectedBoard = {this.props.selectedBoard}/>
        }


        return (
            <div className="teacher-engagement-list">
                <div ><img className="back-icon cursor-pointer" onClick={() => this.back()} src={getImageSource(ImageConstants.BACK_ICON)} /></div>
                <div className="d-flex align-items-center mt-3">
                    <img className="suitcase-icon mr-2" src={getImageSource(ImageConstants.BLACK_SUITCASE_ICON)} />
                    <span className="class-engagement-title">Teacher Engagement</span>
                </div>
                <div className="table-wrapper mt-3">
                    <table className="table table-bordered" style={{ border: 'none' }}>
                        <thead className="class-header">
                            <tr className="first-header-bg">
                                <th className="border-top-left-radius" width='40%'>Teacher Name</th>
                                <th className="">#Assignment</th>
                                <th>Completion Rate</th>
                                <th className="border-top-right-radius">Engagement Score</th>
                            </tr>
                        </thead>
                        <tbody id="rows" className="class-body">
                            {
                                this.state.teachersList && this.state.teachersList.length ? this.state.teachersList.map(item => (
                                    <tr>
                                        <td className="teacher-name">
                                            <div className="d-flex flex-wrap teacher-name-text cursor-pointer" onClick={() => { this.showTeacherEngagementScore(item) }}>
                                                {`${item.gender ? item.gender : ''} ${item.firstName ? item.firstName : ''}  ${item.lastName ? item.lastName : ''}`}
                                            </div>
                                        </td>
                                        <td className="assignment-count">
                                            {item.totalAssignment ? item.totalAssignment : 0}
                                        </td>
                                        <td className="assignment-count">
                                            {`${item.completionRate ? item.completionRate : 0}%`}
                                        </td>
                                        <td className="assignment-count">
                                            {item.engagementScore ? Math.ceil(item.engagementScore) : 0}
                                        </td>
                                    </tr>
                                ))

                                    :
                                    <tr>
                                        <td colSpan="5" align='center'> No Records Found</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>


            </div>
        )
    }

}

export default TeacherEngagementList;